import React from 'react'
import List from './List'

const ContactList = ({...rest}) =>
  <List {...rest} />

export default ContactList



// WEBPACK FOOTER //
// ./src/components/ContactList/index.js